module.exports = __webpack_public_path__ + "static/img/pomelo.bca09b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pomelo.png
// module id = FX9Q
// module chunks = 70